export default __webpack_public_path__ + "static/p2-e29fa277ae29b0c75a6f5fba2a1ee3e6.png";